import * as z from "zod";
import { gql } from "graphql-request";

import { NewsEntry } from "./newsEntry";
import { NewsEntryArticle, NewsEntryArticleFragment } from "./newsEntryArticle";
import {
  SmallNewsEntryArticle,
  SmallNewsEntryArticleFragment,
} from "./smallNewsEntryArticle";

import { SysFragment } from "../sys";
import { ImageFragment } from "../image";

export const BlogNewsEntry = NewsEntry.extend({
  localized: z
    .union([z.null(), z.unknown(), NewsEntryArticle, SmallNewsEntryArticle])
    .nullable(),
});

export type BlogNewsEntry = z.infer<typeof BlogNewsEntry>;

export const BlogNewsEntryFragment = gql`
  fragment BlogNewsEntryFragment on NewsEntry {
    sys {
      ...SysFragment
    }

    categoryEn: category(locale: "en") {
      categoryId
      name
      color
    }

    category {
      categoryId
      name
      color
    }

    newUntil
    sortDate
    localized {
      __typename
      ... on NewsEntryArticle {
        ...NewsEntryArticleFragment
      }

      ... on SmallNewsEntryArticle {
        ...SmallNewsEntryArticleFragment
      }
    }
  }

  ${SysFragment}
  ${ImageFragment}
  ${NewsEntryArticleFragment}
  ${SmallNewsEntryArticleFragment}
`;
